import { combineReducers } from 'redux';
import solgressReducer from './solgressReducer';

export default combineReducers({
    solgressReducer
});